import { Outlet, NavLink } from "react-router-dom";
import { useState } from "react";

import "../colors.css"
import "./navMenu.css"

export default function NavMenu () {
    let time  = new Date().toUTCString();

    const [ctime,setTime] = useState(time)
    const UpdateTime=()=>{
        time =  new Date().toLocaleTimeString()
        setTime(time)
    }
    setInterval(UpdateTime)

    return (
        <>
            <nav className="navbar primary-color">
                <div className="navbar-left">
                    <span>FREIKE.DE</span>
                </div>
                <div className="navbar-center primary-color">
                    <ul className="nav-links">
                        <li className="primary-to-secondary-invert">
                            <NavLink to="/">Home</NavLink>
                        </li>
                        <li className="primary-to-secondary-invert">
                            <NavLink to="/impressum">About</NavLink>
                        </li>
                        <li className="dropdown primary-to-secondary-invert">
                            <NavLink to="/atctools">ATC Tools</NavLink>
                            <ul className="dropdown-content primary-to-secondary-invert">
                                <li>
                                    <NavLink to="http://atctools.freike.de">ATC Stripboard</NavLink>
                                </li>
                                <li>
                                    <NavLink to="/atctools/radarsim">Radar Sim</NavLink>
                                </li>
                            </ul>
                        </li>

                    </ul>
                    
                    
                    
                </div>
                <div className="navbar-right">
                    <div className="clock">
                        UTC: {ctime}
                    </div>
                </div>
                
            </nav>
            <Outlet />
        </>
    );
}